module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray@3x-25a30525e783a00783ec0e658a9ffb74.png";